import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentCalendarAdd = forwardRef<
  Svg,
  { fillColor?: string; color?: string; secondaryColor?: string; size?: number } & SvgProps
>(
  (
    {
      fillColor = '#212121',
      color = fillColor,
      secondaryColor,
      size = 24,
      ...props
    }: { fillColor?: string; color?: string; secondaryColor?: string; size?: number } & SvgProps,
    ref
  ) => {
    const circleColor = secondaryColor || color

    return (
      <Svg
        ref={ref}
        width={size}
        height={size}
        fill='none'
        viewBox='0 0 24 24'
        {...props}
      >
        <Path
          d='M17.75 3A3.25 3.25 0 0121 6.25V12.023a6.5 6.5 0 00-8.977 8.977L6.25 21A3.25 3.25 0 013 17.75V6.25A3.25 3.25 0 016.25 3h11.5zM19.5 8.5H4.5v9.25c0 .966.784 1.75 1.75 1.75h5.065a6.5 6.5 0 018.185-8.185V8.5zM7.75 14.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM7.75 10.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 10.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM17.75 4.5H6.25A1.75 1.75 0 004.5 6.25V7h15v-.75a1.75 1.75 0 00-1.75-1.75z'
          fill={color}
        />
        <Path
          d='M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM17.5 14l-.09.008a.5.5 0 00-.402.402L17 14.5V17h-2.5l-.09.008a.5.5 0 00-.402.402L14 17.5l.008.09a.5.5 0 00.402.402l.09.008H17v2.5l.008.09a.5.5 0 00.402.402l.09.008.09-.008a.5.5 0 00.402-.402L18 20.5V18h2.5l.09-.008a.5.5 0 00.402-.402L21 17.5l-.008-.09a.5.5 0 00-.402-.402L20.5 17H18v-2.5l-.008-.09a.5.5 0 00-.402-.402L17.5 14z'
          fill={circleColor}
        />
      </Svg>
    )
  }
)

export default FluentCalendarAdd
